import { adjustedFlowActionTypes, launchActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { changeData } from '@actions/ssap/ssapActionCreators';
import { PAGES } from '@constants/ssap/flows/pagesTypes';

export const MIDDLEWARE_ON_INTERCEPT_ACTION = {
    type: launchActionTypes.CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED
};

export const customMiddleware = store => next => action => {
    if(action.type === adjustedFlowActionTypes.ADJUST_FLOW && action.isEqual === true) {

        store.dispatch(MIDDLEWARE_ON_INTERCEPT_ACTION);

        const {
            adjustedFlow,
            data
        } = store.getState().ssap;

        const reopenedForEditing = data.reopenedForEditing;

        if(reopenedForEditing) {
            const eligibleAptcPageIndex = adjustedFlow
                .findIndex(p => p.pageName === PAGES.RECONCILIATION_IN_APTC_PAGE && p.isActive);

            const dataWithAdjustedMaxAchievedPage = {
                ...data,
                maxAchievedPage: eligibleAptcPageIndex !== -1 ? eligibleAptcPageIndex: data.maxAchievedPage,
                reopenedForEditing: false
            };

            store.dispatch(changeData(dataWithAdjustedMaxAchievedPage));
        }
    }

    next(action);
};